// extracted by mini-css-extract-plugin
export default {"popconfirm":"src-components-DeletePopconfirm-DeletePopconfirm__popconfirm--HVYOs"};